import { ErrorInfo, PureComponent, ReactNode } from "react";
import { ErrorFrame } from '../error-frames/error-frame';
import { ChunkLoadError } from "../error-frames/chunk-load-error";

interface ErrorBoundaryState {
  hasError: boolean;
  errorName: string;
  errorText: string;
}

interface ErrorBoundaryProps {
  children: ReactNode;
}


class ErrorBoundaryInner extends PureComponent<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false,
    errorName: '',
    errorText: '',
  };

  static getDerivedStateFromError(error: Error) {
    return {
      hasError: true,
      errorName: error?.name,
      errorText: error?.message || JSON.stringify(error),
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
  }

  render() {
    const { hasError, errorName, errorText } = this.state;
    if (hasError) {

      if (errorName === 'ChunkLoadError') {
        return (
          <ChunkLoadError />
        );
      }

      return (
        <ErrorFrame title="Ошибка" errorText={errorText}>
          <div style={{ textAlign: 'center' }}>
            При загрузке страницы произошла ошибка.
            <br/>
            Обратитесь в техподдержку.
          </div>
        </ErrorFrame>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundaryInner;import { ErrorInfo, PureComponent, ReactNode } from "react";
import { ErrorFrame } from '../error-frames/error-frame';
import { ChunkLoadError } from "../error-frames/chunk-load-error";

interface ErrorBoundaryState {
  hasError: boolean;
  errorName: string;
  errorText: string;
}

interface ErrorBoundaryProps {
  children: ReactNode;
}


class ErrorBoundaryInner extends PureComponent<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false,
    errorName: '',
    errorText: '',
  };

  static getDerivedStateFromError(error: Error) {
    return {
      hasError: true,
      errorName: error?.name,
      errorText: error?.message || JSON.stringify(error),
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
  }

  render() {
    const { hasError, errorName, errorText } = this.state;
    if (hasError) {

      if (errorName === 'ChunkLoadError') {
        return (
          <ChunkLoadError />
        );
      }

      return (
        <ErrorFrame title="Ошибка" errorText={errorText}>
          <div style={{ textAlign: 'center' }}>
            При загрузке страницы произошла ошибка.
            <br/>
            Обратитесь в техподдержку.
          </div>
        </ErrorFrame>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundaryInner;